const defaultUrl = "https://admin.phonixphone.fr/";

export default defaultUrl; 